import { render, staticRenderFns } from "./FundsOperationsForm.vue?vue&type=template&id=22b93ac2&"
import script from "./FundsOperationsForm.vue?vue&type=script&lang=js&"
export * from "./FundsOperationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports